/* eslint-disable @typescript-eslint/no-magic-numbers */
const APPLE_PAY_INCREASE = 100;

export const formatApplePayPrice = (amount?: number | null, currency?: string): number =>
  parseInt(
    `${(amount || 0) * (currency === 'SAR' || currency === 'AED' || currency === 'QAR' ? APPLE_PAY_INCREASE : 1000)}`,
    10
  );
